import { AnalysisType } from './analysis-type.enum';

export class Analysis {
    code?: string;
    sequence?: number;
    eurodatKey?: string;
    testCode?: string;
    packageCode?: string;
    subGroupKey?: string;
    isCustomerPackage?: boolean;
    price?: number;
    displayName?: string;
    isFavorite?: boolean;
    analysisType?: AnalysisType;
    subgroupCode?: string;
    preparationTestCodes?: string[];
    isMandatory?: boolean;
    sortIndex?: number;
    structuredComment?: string;
    sampleCode?: string;
    salesCatalogCode?: string;
    testBundleCode?: string;
    testBundleDisplayName?: string;
    monographCode?: string;
    compendiumCode?: string;
    monographName?: string;
    compendiumName?: string;
    executionNumber?:number;
    showSurgeIcon?:boolean;
}
